import React from 'react';
import Modal from 'react-responsive-modal';

import Crying_circly from '../../../img/crying_circly.svg';
import '../../../style/Modal.css';

const ConfirmDeleteBoard = ({ isOpen, onClose, handleDelete }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      closeIconSize={26}
      classNames={{ modal: 'modal-bg', closeIcon: 'close-icon' }}
      center
    >
      <div className="">
        <div className="logout-img">
          <img src={Crying_circly} alt="crying circly" />
        </div>
        <h4 className="m-b-2">Are you sure you want to delete this board?</h4>
        <div className="">
          <button aria-label="No" className="btn btn-secondary m-r-2" onClick={onClose}>
            No
          </button>
          <button aria-label="Yes" className="btn btn-primary" onClick={handleDelete}>
            Yes
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteBoard;
